<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20">

        <el-form :inline="true" :model="searchInput">
          <el-col :span="2">
            <el-form-item>
              <el-button plain class="add-column-btn bbox" @click="dialogFormVisible = true" type="primary">
                <i class="el-icon-plus fw900 f16"></i> 新增</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="searchInput.platform" placeholder="平台类型"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="searchInput.account" placeholder="账号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-date-picker value-format="yyyy-MM-dd" v-model="searchInput.consumDt" type="date" placeholder="消费日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item>
              <el-button type="primary" style="margin-left: 20px" @click="search()">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <!-- 用户列表区域 -->
      <div>

        <el-table :data="tableData" border fit highlight-current-row style="width: 100%" :height="height + 'px'"
          @sort-change="sortChange">
          <el-table-column label="消费日期" align="center" prop="消费日期" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.consumDt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="消费金额" align="center" prop="消费金额">
            <template slot-scope="scope">
              <span>{{ scope.row.consumAmount }}</span>
            </template>
          </el-table-column>

          <el-table-column label="展现次数" align="center" prop="展现次数">
            <template slot-scope="scope">
              <span>{{ scope.row.showCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="点击次数" align="center" prop="点击次数">
            <template slot-scope="scope">
              <span>{{ scope.row.clickCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="平均点击价格" align="center" prop="平均点击价格" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.clickAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="获客数" align="center" prop="获客数">
            <template slot-scope="scope">
              <span>{{ scope.row.customerNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="获客单价" align="center" prop="获客单价">
            <template slot-scope="scope">
              <span>{{ scope.row.customerUnitPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" prop="创建时间" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.createDt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建人" align="center" prop="创建人" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.createor }}</span>
            </template>
          </el-table-column>
          <el-table-column label="平台类型" align="center" prop="平台类型">
            <template slot-scope="scope">
              <span>{{ scope.row.platform }}</span>
            </template>
          </el-table-column>
          <el-table-column label="账号" align="center" prop="账号" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.account }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="账号类型" align="center"  prop="账号类型" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.accountTypeCode }}</span>
                        </template>
                    </el-table-column> -->
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
                <i class="el-icon-edit textblue f16" @click="gotoDetail(scope.row)"></i>
              </el-tooltip>
              <!-- <el-tooltip
                                class="item"
                                effect="dark"
                                content="删除"
                                placement="bottom"
                        >
                            <i
                                    class="el-icon-delete textblue f16 ml20"
                                    @click="del(scope.row.id)"
                            ></i>
                        </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage" :page-sizes="[100, 10, 20, 30, 50]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>
    <!-- 新增弹窗 -->
    <el-dialog title="新增: " :visible.sync="dialogFormVisible" style="width: 60%; margin: 0 auto" center>
      <div class="tableBox">
        <el-form :inline="true" :model="editForm" label-position="right" label-width="120px" style="margin-left: 20px">
          <el-col :span="24">
            <el-form-item label="消费金额：">
              <el-input v-model="editForm.consumAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="消费日期：">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="editForm.consumDt" type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="展示次数：">
              <el-input v-model="editForm.showCount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="点击数量：">
              <el-input v-model="editForm.clickCount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="获客数：">
              <el-input v-model="editForm.customerNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="平台类型：">
              <el-input v-model="editForm.platform"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="账号：">
              <el-input v-model="editForm.account"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div class="twonbtn" style="width: 50%; margin: 20px auto">
          <el-button type="primary" style="margin-right: 20px" @click="submitForm">保存</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 180, //表格高度
      value: "",
      searchInput: {
        platform: "",
        account: "",
        consumDt: "",
      },
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 100,
        //查询条件
        condition: {
          id: "",
        },
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      //------------------------------------
      dialogFormVisible: false,
      editForm: {
        consumAmount: "",
        consumDt: "",
        showCount: "",
        clickCount: "",
        customerNum: "",
        platform: "",
        account: "",
      },
      consumedate: "",
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
    var that = this;
    document.onkeydown = function (e) {   //按下回车提交
      let key = window.event.keyCode;
      //事件中keycode=13为回车事件
      if (key == 13) {
        that.getListData();
      }
    };
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() { },
    //跳转到详情
    gotoDetail(row) {
      console.log("row==>", row);
      var that = this;
      that.editForm.consumAmount = row.consumAmount;
      that.editForm.consumDt = row.consumDt;
      that.editForm.showCount = row.showCount;
      that.editForm.clickCount = row.clickCount;
      that.editForm.customerNum = row.customerNum;
      that.editForm.platform = row.platform;
      that.editForm.account = row.account;
      that.editForm.id = row.id;
      that.dialogFormVisible = true;
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/consume/delete", { id: id })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            that.getListData();
          });
      }
    },
    // 提交弹窗
    submitForm() {
      var that = this;
      that.editForm.createor = JSON.parse(
        localStorage.getItem("loginName")
      ).value;
      that.$http
        .post("/consume/save", that.editForm)
        .then(function (response) {
          console.log('response==>', response);
          if (response.data.code === 200) {
            that.$notify.success({
              title: "提示",
              message: "保存成功",
              showClose: true,
            });
            that.editForm = {};
            that.dialogFormVisible = false;
            that.getListData();
          } else {
            that.$notify.error({
              title: "提示",
              message: response.data.message,
              showClose: true,
            });
          }
        })
        .catch(function (error) {
          that.$notify.info({
            title: "提示",
            message: "保存失败",
            showClose: true,
          });
        });
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      that.$http
        .post("/consume/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            for (let i = 0; i < that.tableData.length; i++) {
              that.tableData[i].consumDt = that
                .timeFormate(response.data.data.data[i].consumDt)
                .substr(0, 11);
              that.tableData[i].createDt = that
                .timeFormate(response.data.data.data[i].createDt)
                .substr(0, 11);
            }
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    // 时间格式化
    timeFormate(originVal) {
      const dt = new Date(originVal);

      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");

      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      // yyyy-mm-dd hh:mm:ss
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
  },
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}

.el-form-item--small.el-form-item {
  margin-bottom: 5px !important;
}

.el-card {
  height: calc(100vh - 100px);
  position: relative;

  /deep/.el-card__body {
    padding: 0 20px 10px 20px !important;
  }

  .el-select>.el-input {
    width: 200px;
  }

  .header-search-box .header-search-input {
    width: 325px;
  }

  input::placeholder {
    font-size: 12px;
  }

  .handle-btn .el-button.add-column-btn {
    width: 100%;
    font-size: 13px;
    background-color: transparent;
    color: #008eff;
    z-index: 102;
  }

  .footerBox {
    position: absolute;
    width: 100%;
    // height: 78px;
    left: 20px;
    right: 20px;
    bottom: 0;
  }
}


/deep/.el-scrollbar__view {
  min-width: 100%;
}

/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}

/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

//日期选择器
/deep/.el-date-editor.el-input {
  width: 188.5px;
}
</style>
